export default () => ({
  status: undefined,
  url: "",
  resumeTime: undefined,
});
